import React from "react";
import ajax from "../../lib/ajax";

export default class InstantMessage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            htmlContent : null
        };
    }

    componentDidMount() {
        const pageName = this.props.pageName;

        ajax.api()
            .get(`get-page/${pageName}`)
            .then(r => {
                this.setState({
                    htmlContent : r.data.htmlContent
                });            
            });            
    }

    render() {
        if (this.state.htmlContent == null) {
            return null;
        } else {
            return (
            <div className="ap-announcement-panel" dangerouslySetInnerHTML={{ __html: this.state.htmlContent}} >
            </div>)
        }
    }
}